module.exports = __webpack_public_path__ + "img/03.0ab8bb7a.png";